import { useMemo } from 'react'
import { Column } from 'react-table'
import Table from '../../../global/components/table/Table'
import DeleteButton from '../../../global/components/buttons/delete-button/DeleteButton'

export interface DocumentListItem {
  documentObjectId: string
  name: string
  description: string
  totalChunks?: number
  uploadedAt: string
}

interface DocumentTableProps {
  documents: DocumentListItem[]
  isLoading: boolean
  onDelete: (documentObjectId: string) => void
}

function DocumentTable({ documents, isLoading, onDelete }: DocumentTableProps) {
  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Chunks',
        Cell: ({ row }: any) =>
          row.original.totalChunks != null ? row.original.totalChunks : '-',
      },
      {
        Header: 'Uploaded',
        Cell: ({ row }: any) =>
          row.original.uploadedAt
            ? new Date(row.original.uploadedAt).toLocaleDateString()
            : '-',
      },
      {
        Header: 'Actions',
        Cell: ({ row }: any) => (
          <DeleteButton
            buttonName='Delete'
            onClick={(e) => {
              e.stopPropagation()
              onDelete(row.original.documentObjectId)
            }}
          />
        ),
      },
    ],
    [onDelete],
  )

  return (
    <Table
      columns={columns}
      data={documents}
      isLoading={isLoading}
      isDisplayMode={true}
      noDataMessage='No documents uploaded yet.'
    />
  )
}

export default DocumentTable
